<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.procedimento"
                    :request-query-string-params="autocompleteQueryStringParams.procedimento"
                    :search-fields="fields.autocompletes.procedimentoSolicitado"
                    :validations="validations.procedimentoSolicitado"
                    label="Procedimento solicitado"
                    placeholder="Digite o código ou nome do procedimento relacionado ao CID principal inserido. Para visualizar todos, clique na lupa ao lado."
                    v-model="model.procedimentoSolicitado"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-button
                            @click="$refs.ModalBuscaProcedimento.open({ cid, registro: 'aih', onlyWithCid: true })"
                            color="primary"
                            title="Buscar procedimentos relacionados"
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </rkm-input-group-append>

                </rkm-form-input-autocomplete>

            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    :max-date="additionals.dataAtual"
                    :validations="validations.dataSolicitacao"
                    label="Data da solicitação"
                    v-model="model.dataSolicitacao"
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-select
                    :options="form.clinicas"
                    :validations="validations.clinica"
                    label="Clínica"
                    show-default-option
                    text-field="nome"
                    v-model="model.clinicaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.caratersInternacao"
                    :validations="validations.caraterInternacao"
                    label="Caráter de internação"
                    show-default-option
                    text-field="nome"
                    v-model="model.caraterInternacaoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input-autocomplete
                    disabled
                    :repository="repositories.usuario"
                    :search-fields="fields.autocompletes.profissionalSolicitanteAssistente"
                    :validations="validations.profissionalSolicitanteAssistente"
                    label="Nome do profissional solicitante / Assistente"
                    v-model="model.profissionalSolicitanteAssistente"
                    text-field="cidadaoNome"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="disabledDocumentoNumero"
                    :label="false"
                    :mask="documentoNumeroMask"
                    :readonly="!model.profissionalSolicitanteDocumentoTipoId"
                    :validations="validations.documentoNumero"
                    name="Número do documento"
                    v-model="model.profissionalSolicitanteDocumentoNumero"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-radio-group
                                :disabled="!model.profissionalSolicitanteAssistente"
                                :options="form.documentos"
                                text-field="nome"
                                v-model="model.profissionalSolicitanteDocumentoTipoId"
                                value-field="id"
                            />
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <ModalBuscaProcedimento
            ref="ModalBuscaProcedimento"
            title="Procedimentos compatíveis ao CID principal selecionado"
            @select="model.procedimentoSolicitado = $event"
        />
    </div>
</template>


<script>
import { repository, mask, object } from '@/mixins'
import tipoDocumento from '@/enums/cadastro/documentoTipo'
import ModalBuscaProcedimento from '@/components/sigtap/procedimento/busca/Modal'
import { mapGetters } from 'vuex'


export default  {
    components:{ModalBuscaProcedimento},
    computed:{
        ...mapGetters({
            autenticacao: 'getAutenticacao',
        }),
        autocompleteQueryStringParams() {

            return {
                procedimento: {
                    registro: 'aih',
                    cid_id: this.getSafely(() => this.cid.id),
                    only_with_cid: true
                }
            }
        },

        fields() {

            return {
                autocompletes: {
                    procedimentoSolicitado: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                    profissionalSolicitanteAssistente: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ]
                }
            }
        },
        validations() {

            return {
                procedimentoSolicitado: { required: true },
                dataSolicitacao: { required: true },
                clinica: { required: true },
                caraterInternacao: { required: true },
                profissionalSolicitanteAssistente: { required: true },
                documentoNumero: {
                    required: true,
                    cns: this.model?.profissionalSolicitanteDocumentoTipoId === this.enums.tipoDocumento.CNS,
                    cpf: this.model?.profissionalSolicitanteDocumentoTipoId === this.enums.tipoDocumento.CPF
                },
            }
        },

        documentoNumeroMask() {

            switch (this.model?.profissionalSolicitanteDocumentoTipoId) {

                case this.enums.tipoDocumento.CNS: {

                    return this.mask.cns
                }
                case this.enums.tipoDocumento.CPF: {

                    return this.mask.cpf
                }
                default: {

                    return ''
                }
            }
        },

        disabledDocumentoNumero() {

            if (!this.model.profissionalSolicitanteAssistente) {

                return true
            }

            switch (this.model?.profissionalSolicitanteDocumentoTipoId) {

                case this.enums.tipoDocumento.CNS: {

                    return !!this.model.profissionalSolicitanteAssistente.cidadaoCns
                }
                case this.enums.tipoDocumento.CPF: {

                    return !!this.model.profissionalSolicitanteAssistente.cidadaoCpf
                }
                default: {

                    return false
                }
            }
        }
    },
    methods:{
        getProfissionalSolicitantePadrao() {
            const usuario = this.autenticacao?.usuario

            if (!usuario?.id) {
                return null
            }

            return {
                id: usuario.id,
                cidadaoNome: usuario?.cidadao?.nome ?? usuario?.nome ?? null,
                cidadaoCns: usuario?.cidadao?.cns ?? usuario?.cidadaoCns ?? null,
                cidadaoCpf: usuario?.cidadao?.cpf ?? usuario?.cidadaoCpf ?? null,
            }
        },
        normalizeCns(profissional) {
            return profissional?.cidadaoCns
                ?? profissional?.cidadao?.cns
                ?? null
        },
        normalizeCpf(profissional) {
            return profissional?.cidadaoCpf
                ?? profissional?.cidadao?.cpf
                ?? null
        },
        preencherDocumentoNumero() {
            switch (this.model?.profissionalSolicitanteDocumentoTipoId) {
                case this.enums.tipoDocumento.CNS: {
                    this.model.profissionalSolicitanteDocumentoNumero = this.normalizeCns(this.model.profissionalSolicitanteAssistente)
                    break
                }
                case this.enums.tipoDocumento.CPF: {
                    this.model.profissionalSolicitanteDocumentoNumero = this.normalizeCpf(this.model.profissionalSolicitanteAssistente)
                    break
                }
                default: {
                    this.model.profissionalSolicitanteDocumentoNumero = ''
                    break
                }
            }
        }

    },
    created(){
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }

        if (!this.model?.profissionalSolicitanteAssistente) {
            this.model.profissionalSolicitanteAssistente = this.getProfissionalSolicitantePadrao()
        }

        if (!this.model?.profissionalSolicitanteDocumentoTipoId) {
            this.model.profissionalSolicitanteDocumentoTipoId = this.enums.tipoDocumento.CNS
        }

        this.$nextTick().then(() => {
            if (!this.model?.profissionalSolicitanteDocumentoNumero) {
                this.preencherDocumentoNumero()
            }
        })
    },
    data: () => ({
        enums: { tipoDocumento },
    }),
    mixins: [repository, mask, object],
    props: {
        cid: { type: Object },
        additionals: { type: Object, required: false },
        form: { type: Object, required: false },
        model: { type: Object, required: false }
    },
    watch: {
        cid(cid) {

            if (!cid) {

                this.model.procedimentoSolicitado = null
            }
        },
        'model.profissionalSolicitanteAssistente'() {
            if (!this.model?.profissionalSolicitanteDocumentoNumero) {
                this.$nextTick().then(() => {
                    this.preencherDocumentoNumero()
                })
            }
        },
        'model.profissionalSolicitanteDocumentoTipoId'() {

            this.$nextTick().then(() => {
                this.preencherDocumentoNumero()
            })
        }
    }
}

</script>